import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetCumulativeRevenueDto } from '../../../models/analytics/dto/get-cumulative-revenue.dto';
import { AnalyticsFilterParams, buildFilterSuffix } from './analyticsFilterParams';

export const GET_CUMULATIVE_REVENUE_QUERY_KEY = 'getCumulativeRevenue';

export const useGetCumulativeRevenue = (locationId: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_CUMULATIVE_REVENUE_QUERY_KEY, locationId, startDate?.getTime(), endDate?.getTime(), filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            let url = `analytics/cumulative-revenue?locationId=${locationId}`;
            if (startDate && endDate) {
                url += `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
            }
            url += buildFilterSuffix(filters);
            const response = await apiClient.fetchApi<GetCumulativeRevenueDto, {}>({ method: 'GET', endpoint: url });
            return response;
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
};
